import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { DEFAULT_LOCALE, isLocale } from './config';

/**
 * Locale from the `:locale` route segment of public pages; on pages without one (the dashboard)
 * the language i18next is in, which the language menu switches.
 */
export function useLocale(): string {
  const { locale } = useParams();
  const { i18n } = useTranslation();
  if (isLocale(locale)) return locale;
  return isLocale(i18n.language) ? i18n.language : DEFAULT_LOCALE;
}
